import React from 'react';
import PropTypes from 'prop-types';
import { v1 as uuid } from 'uuid';
import { FormattedMessage } from 'react-intl';
import theme from '../../themes/tradeRev/theme';

import Button from '../Button';

import {
  StyledAlert,
  StyledMessages,
  StyledIcon,
  StyledMessage,
  StyledDismiss,
  StyledDismissIcon
} from './Styles';

const propTypes = {
  variant: PropTypes.oneOf(['success', 'information', 'warning', 'error'])
    .isRequired,
  messages: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.object, PropTypes.string])
  ).isRequired,
  classname: PropTypes.string,
  isOmp: PropTypes.bool
};

const defaultProps = {
  isOmp: false,
  classname: undefined
};

/**
 * Returns the icon name for a specified variant
 * @param {String}
 * @return {String}
 */
function getAlertIcon(variant, isOmp) {
  if (isOmp) {
    return `TR5-OMP${variant.charAt(0).toUpperCase() + variant.slice(1)}_msg`;
  }
  return `TR5-${variant.charAt(0).toUpperCase() + variant.slice(1)}_msg`;
}

/**
 * Returns the icon color for a specified variant
 * @param {String}
 * @return {String}
 */
function getAlertIconColor(variant) {
  switch (variant) {
    case 'success':
      return theme.COLORS.SUCCESS;
    case 'information':
      return theme.COLORS.INFO;
    case 'warning':
      return theme.COLORS.WARNING;
    case 'error':
      return theme.COLORS.ERROR;
    default:
      return undefined;
  }
}

const Alert = ({ classname, variant, messages, isOmp }) => (
  <StyledAlert
    data-testid="toaster-message"
    classname={classname}
    variant={variant}
  >
    <StyledMessages multipleMessages={messages?.length > 1}>
      {messages.map(message => {
        return (
          <StyledMessage key={uuid()}>
            <StyledIcon
              icon={getAlertIcon(variant, isOmp)}
              color={getAlertIconColor(variant)}
            />
            {message}
          </StyledMessage>
        );
      })}
    </StyledMessages>
    <StyledDismiss isOmp={isOmp}>
      {isOmp ? (
        <StyledDismissIcon />
      ) : (
        <>
          <Button.Transparent data-testid="toaster-dismiss">
            <FormattedMessage id="toaster.dismiss.message" />
          </Button.Transparent>
        </>
      )}
    </StyledDismiss>
  </StyledAlert>
);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;

export default Alert;
